import { render, staticRenderFns } from "./ModernTimeDimensionRow.vue?vue&type=template&id=1b20bd6e&scoped=true&"
import script from "./ModernTimeDimensionRow.vue?vue&type=script&lang=js&"
export * from "./ModernTimeDimensionRow.vue?vue&type=script&lang=js&"
import style0 from "./ModernTimeDimensionRow.vue?vue&type=style&index=0&id=1b20bd6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b20bd6e",
  null
  
)

export default component.exports